import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function WarningIcon({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="500.000000pt"
      height="500.000000pt"
      viewBox="0 0 500.000000 500.000000"
      preserveAspectRatio="xMidYMid meet"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <g
        transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
        stroke="none"
      >
        <path
          d="M2345 4993 c-405 -22 -863 -175 -1205 -400 -617 -408 -1011 -1032
   -1116 -1768 -20 -145 -23 -464 -5 -610 82 -665 407 -1249 926 -1664 161 -128
   288 -209 458 -291 251 -121 477 -191 742 -231 185 -29 491 -31 680 -5 827 113
   1550 632 1910 1371 126 257 195 477 236 750 41 266 28 619 -31 885 -162 728
   -643 1354 -1292 1686 -414 210 -844 302 -1303 277z m301 -1138 c113 -33 198
   -119 235 -236 l20 -66 -25 -629 c-15 -346 -31 -647 -37 -669 -16 -61 -53 -118
   -109 -168 -133 -120 -331 -118 -466 5 -57 53 -84 95 -103 163 -13 49 -64 1264
   -55 1320 21 128 111 233 237 276 66 23 232 25 303 4z m-74 -2026 c109 -23 198
   -95 246 -197 23 -49 27 -70 27 -152 0 -76 -4 -104 -22 -142 -32 -71 -103 -141
   -176 -174 -54 -25 -73 -29 -152 -29 -81 1 -96 4 -150 32 -116 60 -183 161
   -192 289 -13 173 94 325 257 368 68 18 95 19 162 5z"
        />
      </g>
    </svg>
  )
}
